var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "66042BB4-F7DE-4653-987C-6E31F48D70F9@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.37920647,0 C10.4628029,0 12.3509723,1.67791622 12.6440134,4.73181582 L12.65,4.85689696 L12.649,6.325 L12.7583333,6.325 C13.8629028,6.325 14.7583333,7.2204305 14.7583333,8.325 L14.7583333,14.8666667 C14.7583333,15.9712362 13.8629028,16.8666667 12.7583333,16.8666667 L2,16.8666667 C0.8954305,16.8666667 -9.74952274e-16,15.9712362 0,14.8666667 L0,8.325 C-5.7935996e-16,7.2204305 0.8954305,6.325 2,6.325 L2.108,6.325 L2.10833333,4.85689696 L2.11432271,4.73178714 C2.40743038,1.677901 4.29561991,0 7.37920647,0 Z M7.37920647,2.54753171 C5.56625956,2.54753171 4.76374775,3.24205201 4.58568172,4.92266311 L4.585,6.325 L10.172,6.325 L10.1726516,4.92264795 C9.99462732,3.24204074 9.19214833,2.54753171 7.37920647,2.54753171 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Private"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.666667, 2.933333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-Colors/White",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.666667, -2.933333)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockWhite);
export default __webpack_public_path__ + "static/media/lock-white.941262cb0229cf109608b23c4b8ec665.svg";
export { ForwardRef as ReactComponent };